export enum TopLevelModes {
  Translate = "translate",
  LangCoach = "langcoach",
  DailyLife = "dailylife",
  ArgumentBattle = "argumentbattle",
  ImproTest = "improtest",
  Explainer = "explainer",
}

export type ModeType = {
  topLevelMode?: TopLevelModes;
  modeStr: string;
  subMode?: string;
  color?: string; // Optional color for the mode
  hasInitialContext?: boolean; // Whether this mode has an initial setup/context message from the server
};

const Modes: { [key: string]: ModeType } = {};
Modes.Translate = {
  modeStr: TopLevelModes.Translate,
};
Modes.LangCoach = {
  topLevelMode: TopLevelModes.LangCoach,
  modeStr: TopLevelModes.LangCoach,
  hasInitialContext: true,
};
Modes.DailyLifeGroceries = {
  topLevelMode: TopLevelModes.DailyLife,
  modeStr: `${TopLevelModes.DailyLife}.groceries`,
  subMode: "groceries",
  hasInitialContext: true,
};
Modes.DailyLifeRestaurant = {
  topLevelMode: TopLevelModes.DailyLife,
  modeStr: `${TopLevelModes.DailyLife}.restaurant`,
  subMode: "restaurant",
  hasInitialContext: true,
};
Modes.DailyLifeMedical = {
  topLevelMode: TopLevelModes.DailyLife,
  modeStr: `${TopLevelModes.DailyLife}.medical`,
  subMode: "medical",
  hasInitialContext: true,
};
Modes.ArgumentBattle = {
  topLevelMode: TopLevelModes.ArgumentBattle,
  modeStr: TopLevelModes.ArgumentBattle,
  hasInitialContext: true,
};
Modes.ImproTest = {
  topLevelMode: TopLevelModes.ImproTest,
  modeStr: TopLevelModes.ImproTest,
  hasInitialContext: true,
};
Modes.ExplainerExplain = {
  topLevelMode: TopLevelModes.Explainer,
  modeStr: `${TopLevelModes.Explainer}.explain`,
  subMode: "explain",
  hasInitialContext: true,
};
Modes.ExplainerProblemSolver = {
  topLevelMode: TopLevelModes.Explainer,
  modeStr: `${TopLevelModes.Explainer}.problemsolve`,
  subMode: "problemsolve",
  hasInitialContext: true,
};

const getChildSubmodes = (mode: TopLevelModes): ModeType[] => {
  const subModes = Object.values(Modes).filter((m) => m.topLevelMode === mode);
  return subModes;
};

const getModeByName = (modeStr: string): ModeType | undefined => {
  const mode = Object.values(Modes).find((m) => m.modeStr === modeStr);
  if (!mode) {
    console.error(`Mode ${modeStr} not found`);
    return undefined;
  }
  return mode;
};

export { Modes, getChildSubmodes, getModeByName };
